module.exports = __webpack_public_path__ + "img/2_16.998c9378.jpg";